<template>
  <div class="pt-1">
    <b-list-group>
      <b-list-group-item v-for="(day, n) in currentDays" :key="n">
        <div class="d-flex justify-content-between align-items-center pb-1">
          <small class="text-muted">{{ day.format("dddd") }}</small>
          <small class="text-muted">{{ day.format("DD.MM.YY") }}</small>
        </div>
        <b-list-group>
          <b-list-group-item
            v-for="item in getRecipesByDate(day)"
            :key="day.unix() + '-' + item.id"
            href="javascript:void(0);"
            class="py-1 px-0 rounded-0 border-0"
            @click="showDetails(item)"
          >
            <div class="d-flex align-items-center">
              <small style="flex:1;"
                ><strong>{{ item.title }}</strong></small
              >
              <small class="text-muted mr-2"
                >{{ item.calories > 0 ? item.calories : "n.a." }} kcal</small
              >
              <b-badge
                v-for="oneType in item.type"
                :key="item.id + '-' + oneType"
                class="recipeType mr-2"
                :variant="getItemVariantColor(oneType)"
                >{{ oneType }}</b-badge
              >
              <b-btn
                @click.stop="removeFromPlan(day, item.id)"
                size="sm"
                variant="light"
                class="border px-1 py-0"
                ><b-icon-x class="text-danger"
              /></b-btn>
            </div>
          </b-list-group-item>
          <b-btn
            @click.stop="setDateAndSearch(day)"
            size="sm"
            variant="light"
            block
            class="px-1 py-0 mt-1"
            ><b-icon-plus class="text-primary"
          /></b-btn>
        </b-list-group>
      </b-list-group-item>
      <infinite-loading @infinite="infiniteHandler" v-if="!loading">
        <div slot="no-more" class="text-muted py-1">
          <small>Keine weiteren Tage verfügbar.</small>
        </div>
        <div slot="no-results" class="text-muted py-1">
          <small>Keine Einträge gefunden.</small>
        </div>
      </infinite-loading>
      <div class="text-center p-4" v-else>
        <b-spinner small></b-spinner>
      </div>
    </b-list-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
// @ is an alias to /src

export default {
  name: "Planer",
  components: {
    InfiniteLoading
  },
  data() {
    return {
      currentDays: [],
      page: 1,
      lastTimeStamp: null
    };
  },
  computed: {
    currentTimeStamp() {
      return this.moment();
    },
    ...mapState({
      // arrow functions can make the code very succinct!
      loading: state => state.loading,
      plan: state => state.plan,
      moment: state => state.moment
    }),
    ...mapGetters(["getRecipesByDate", "getItemVariantColor"])
  },
  methods: {
    showDetails(item) {
      this.$store.commit("SET_DETAILITEM", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-right");
    },
    infiniteHandler($state) {
      var startOfWeek = null;
      if (this.lastTimeStamp !== null) {
        startOfWeek = this.moment(this.lastTimeStamp).add(1, "d");
      } else {
        startOfWeek = this.moment(this.currentTimeStamp);
      }
      var endOfWeek = this.moment(startOfWeek).add(1, "w");
      this.lastTimeStamp = endOfWeek;

      var days = [];
      var day = startOfWeek;

      while (day <= endOfWeek) {
        days.push(day);
        day = day.clone().add(1, "d");
      }
      this.currentDays.push(...days);
      this.page++;
      if (this.page == 3) {
        $state.complete();
      } else {
        $state.loaded();
      }
    },
    removeFromPlan(date, id) {
      this.$bvModal
        .msgBoxConfirm("Möchten Sie diesen Eintrag wirklich löschen?", {
          cancelTitle: "Abbrechen",
          okTitle: "Ja",
          okVariant: "danger"
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch("removeFromPlan", { date: date, id: id });
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err);
        });
    },
    setDateAndSearch(moment) {
      this.$store.commit("SELECTED_DATE", moment);
      this.$store.commit("SEARCH_ACTIVE", true);
      document.getElementById("omnibar-fakeinput").focus();
    }
  }
};
</script>

<style lang="scss"></style>
